import React from 'react'
import axios from 'axios'
import {
  BrowserRouter as Router,
  Route,
  useHistory,
  Redirect,
  Switch,
  Link,
} from 'react-router-dom'
import { AgendarContainer } from './domains/agendamentos/agendar/AgendarContainer'
import { ConsultarRoutes } from './domains/agendamentos/consultar/ConsultarRoutes'
import 'antd/dist/antd.css'
import Home from './domains/home/Home'
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3509/'
export const webservicesBaseURL = process.env.REACT_APP_WEBSERVICES_URL || 'http://localhost:3502'
export const homePath = '/agendamentos'

export const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/agendamentos" component={Home} />
        <Route exact path={`/agendamentos/agendar`} component={AgendarContainer} />
        <Route exact path={`/agendamentos/agendar/:cpf`} component={AgendarContainer} />
        <Route
          exact
          path={`/agendamentos/agendar/:cpfPilotar/:cnpjCfcPilotar/:telefonePilotar/:renach/:tipoProcesso`}
          component={AgendarContainer}
        />
        <Route path={`/agendamentos/consultar`} component={ConsultarRoutes} />
        <Redirect to="/agendamentos" />
      </Switch>
    </Router>
  )
}
